import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import PropTypes from 'prop-types';
import R from 'ramda';
import classnames from 'classnames';

import styles from './section-header.css';

const { h1, header } = hh(h);

const SectionHeader = ({
    theme = 'one',
    classes = [],
    ...props
}) => (
    header({className: styles.container}, [
        h1({className: classnames(styles.sectionHeader, R.prop(theme, styles), ...classes)},
           props.children)])
);

SectionHeader.propTypes = {
    theme: PropTypes.oneOf(['one', 'two', 'big']),
    classes: PropTypes.array
};

export default SectionHeader;



/** WEBPACK FOOTER **
 ** ./src/SectionHeader/index.js
 **/